import React from 'react';
import { Label } from './Label';
import { CALENDLY_URL, EMAIL, EMAIL_URL, GITHUB_URL, LINKEDIN_URL } from '../data/site';
export function Footer() {
  return <footer className="w-full border-t border-cream/12 bg-navy" data-id="element-75" data-mp="3ghc0bvkn0rl2">
      <div className="mx-auto flex max-w-[960px] flex-col gap-10 px-5 py-14 sm:px-8" data-id="element-76" data-mp="32p5lcct80qn7">
        <div data-id="element-77" data-mp="36qhf8uj4ny17">
          <p className="font-serif text-2xl italic text-cream" data-id="element-78" data-mp="36pzblcu4yhj9">Eric Blanvillain</p>
          <p className="mt-2 font-sans text-[11px] uppercase tracking-label text-cream/45" data-id="element-79" data-mp="3ug3gdnj28nbu">
            Business Consultant · Data &amp; AI · Paris
          </p>
        </div>

        <nav aria-label="Contact" className="flex flex-col gap-4 border-t border-cream/12 pt-8 sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-8" data-id="element-80" data-mp="3levhb38pzigp">
          <a href={EMAIL_URL} className="font-sans text-[11px] uppercase tracking-label text-copper underline decoration-copper/50 underline-offset-8 transition-colors duration-200 ease-editorial hover:text-copper-light" data-id="element-81" data-mp="29z6tyark0hfd">
            {EMAIL}
          </a>
          <a href={CALENDLY_URL} target="_blank" rel="noreferrer noopener" className="font-sans text-[11px] uppercase tracking-label text-cream/70 underline decoration-copper/50 underline-offset-8 transition-colors duration-200 ease-editorial hover:text-copper" data-id="element-82" data-mp="3lbddkvg7mdmv">
            Book a call
          </a>
          <a href={LINKEDIN_URL} target="_blank" rel="noreferrer noopener" className="font-sans text-[11px] uppercase tracking-label text-cream/70 underline decoration-copper/50 underline-offset-8 transition-colors duration-200 ease-editorial hover:text-copper" data-id="element-83" data-mp="81pexhlx8v8u">
            LinkedIn
          </a>
          <a href={GITHUB_URL} target="_blank" rel="noreferrer noopener" className="font-sans text-[11px] uppercase tracking-label text-cream/70 underline decoration-copper/50 underline-offset-8 transition-colors duration-200 ease-editorial hover:text-copper" data-id="element-84" data-mp="qt8hjnc1a7ac">
            GitHub
          </a>
          <span className="font-sans text-[11px] uppercase tracking-label text-cream/45" data-id="element-85" data-mp="yupiw2p7cucz">Paris</span>
        </nav>

        <Label tone="cream" data-id="element-86" data-mp="13r7lox0z2imo">© {new Date().getFullYear()} Eric Blanvillain</Label>
      </div>
    </footer>;
}